import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Tabs } from 'primeng/tabs';
import { forkJoin } from 'rxjs';
import {
  PreventMilestone2DesignationEdit,
  MaturityStatus,
  PaymentStatus,
  ProgramTypes
} from '../../../../models/_enum-collections';
import { ApiResponse } from '../../../../models/api-response.model';
import { Milestone2Designation } from '../../../../models/milestone2-designation.model';
import { Milestone2PaymentStatus } from '../../../../models/milestone2-payment-status.model';
import { SpecialInvestmentsMilestoneInvoice } from '../../../../models/special-investments-milestone-invoice.model';
import { SpecialInvestmentsMilestonePayment } from '../../../../models/special-investments-milestone-payment.model';
import { SpecialInvestmentsMilestone2Details } from '../../../../models/special-investments-milestone2-details.model';
import { CommonService } from '../../../common/common.service';
import { OsmosisEditService } from '../../../services/osmosis-edit.service';
import { CommonSharedModule } from '../../../common/shared.module';

@Component({
  selector: 'app-milestone2-payment-special-investment',
  templateUrl: './app-milestone2-payment-special-investment.component.html',
  styleUrls: ['./app-milestone2-payment-special-investment.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class AppMilestone2PaymentSpecialInvestmentComponent implements OnInit {
  @Input() engagementId!: number;
  @Input() isOptOutPartner = true;
  @Input() activityType!: string;
  @Input() isPartnerBlocked!: boolean;
  @Input() partnerMpnid!: number;
  @Input() programTypeId!: ProgramTypes;

  @ViewChild(Tabs, { static: false }) tabView!: Tabs;

  preventM2DesignationEdit!: boolean;
  specialInvestmentsMilestonePayment!: SpecialInvestmentsMilestonePayment;
  specialInvestmentsMilestone2Invoice!: SpecialInvestmentsMilestoneInvoice;
  specialInvestmentsMilestone2Details!: SpecialInvestmentsMilestone2Details;
  isReadonlyMilestone2Payment = true;
  isReadonlyMilestone2Details = true;
  msgsMilestone2InvoiceDetails!: any[];
  msgsMilestone2Details!: any[];
  paymentMilestone2btnNav = false;
  paymentMilestone2DesignationbtnNav = false;
  formSecuritySales!: FormGroup;
  formSecurityACR!: FormGroup;
  formSalesEngagement!: FormGroup;
  formEnabledEngagement!: FormGroup;
  paymentStatus!: Milestone2PaymentStatus[];
  milestone2Designations!: Milestone2Designation[];
  apires!: ApiResponse;
  datePipe = new DatePipe('en-US');
  maxYearDate!: Date;

  selectedDesignation: any;
  showM365SecuritySales = false;
  showSecurityACR = false;
  showSalesEngagement = false;
  showEnabledEngagement = false;
  hasSecurityACR = false;
  hasM365SecuritySales = false;
  hasMilestoneData = false;
  hasVaildPayoutMetric = false;
  showDesignation = false;
  milestone2Details!: SpecialInvestmentsMilestone2Details;
  operatorPaymentStatus: string[] = ['Immature', 'Tier Not Met', 'Expired'];
  selectedTab = 0;

  constructor(
    private osmEdit: OsmosisEditService,
    private formBuilder: FormBuilder,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.onFormGroup();
    this.preventM2DesignationEdit = Object.values(
      PreventMilestone2DesignationEdit
    ).includes(this.activityType as PreventMilestone2DesignationEdit)
      ? true
      : false;
  }

  onFormGroup() {
    this.maxYearDate = new Date(
      new Date().setFullYear(new Date().getFullYear())
    );

    this.formEnabledEngagement = this.formBuilder.group({
      milestone2Designation: [''],
      payoutMetric: [''],
      tier1PaymentAmount: [''],
      tier1MetDate: [''],
      tier2PaymentAmount: [''],
      tier2MetDate: [''],
      tier3PaymentAmount: [''],
      tier3MetDate: [''],
      tier1PaidDate: [''],
      tier2PaidDate: [''],
      tier3PaidDate: [''],
      tier1PaymentDocumentNumber: [''],
      tier2PaymentDocumentNumber: [''],
      tier3PaymentDocumentNumber: [''],
      tier1InvoiceNumber: [''],
      tier2InvoiceNumber: [''],
      tier3InvoiceNumber: [''],
      tier1PaymentStatus: [''],
      tier2PaymentStatus: [''],
      tier3PaymentStatus: [''],
      tier1PaymentCentralTransactionId: [''],
      tier2PaymentCentralTransactionId: [''],
      tier3PaymentCentralTransactionId: [''],
      engagementSubID: [''],
      tier1MaturityDate: [''],
      tier2MaturityDate: [''],
      tier3MaturityDate: [''],
      tier1MaturityStatus: [''],
      tier2MaturityStatus: [''],
      tier3MaturityStatus: [''],
      tier4PaymentAmount: [''],
      tier4MetDate: [''],
      tier4PaidDate: [''],
      tier4PaymentDocumentNumber: [''],
      tier4InvoiceNumber: [''],
      tier4PaymentStatus: [''],
      tier4PaymentCentralTransactionId: [''],
      tier4MaturityDate: [''],
      tier4MaturityStatus: [''],
      tenantId: [''],
      isAcceleratedPayment: ['']
    });

    this.formSalesEngagement = this.formBuilder.group({
      milestone2Designation: [''],
      payoutMetric: [''],
      tier1PaymentAmount: [''],
      tier1MetDate: [''],
      tier2PaymentAmount: [''],
      tier2MetDate: [''],
      tier3PaymentAmount: [''],
      tier3MetDate: [''],
      tier1PaidDate: [''],
      tier2PaidDate: [''],
      tier3PaidDate: [''],
      tier1PaymentDocumentNumber: [''],
      tier2PaymentDocumentNumber: [''],
      tier3PaymentDocumentNumber: [''],
      tier1InvoiceNumber: [''],
      tier2InvoiceNumber: [''],
      tier3InvoiceNumber: [''],
      tier1PaymentStatus: [''],
      tier2PaymentStatus: [''],
      tier3PaymentStatus: [''],
      tier1PaymentCentralTransactionId: [''],
      tier2PaymentCentralTransactionId: [''],
      tier3PaymentCentralTransactionId: [''],
      engagementSubID: [''],
      tier1MaturityDate: [''],
      tier2MaturityDate: [''],
      tier3MaturityDate: [''],
      tier1MaturityStatus: [''],
      tier2MaturityStatus: [''],
      tier3MaturityStatus: [''],
      tier4PaymentAmount: [''],
      tier4MetDate: [''],
      tier4PaidDate: [''],
      tier4PaymentDocumentNumber: [''],
      tier4InvoiceNumber: [''],
      tier4PaymentStatus: [''],
      tier4PaymentCentralTransactionId: [''],
      tier4MaturityDate: [''],
      tier4MaturityStatus: ['']
    });

    this.formSecurityACR = this.formBuilder.group({
      milestone2Designation: [''],
      payoutMetric: [''],
      tier1PaymentAmount: [''],
      tier1MetDate: [''],
      tier2PaymentAmount: [''],
      tier2MetDate: [''],
      tier3PaymentAmount: [''],
      tier3MetDate: [''],
      tier1PaidDate: [''],
      tier2PaidDate: [''],
      tier3PaidDate: [''],
      tier1PaymentDocumentNumber: [''],
      tier2PaymentDocumentNumber: [''],
      tier3PaymentDocumentNumber: [''],
      tier1InvoiceNumber: [''],
      tier2InvoiceNumber: [''],
      tier3InvoiceNumber: [''],
      tier1PaymentStatus: [''],
      tier2PaymentStatus: [''],
      tier3PaymentStatus: [''],
      tier1PaymentCentralTransactionId: [''],
      tier2PaymentCentralTransactionId: [''],
      tier3PaymentCentralTransactionId: [''],
      engagementSubID: [''],
      tier1MaturityDate: [''],
      tier2MaturityDate: [''],
      tier3MaturityDate: [''],
      tier1MaturityStatus: [''],
      tier2MaturityStatus: [''],
      tier3MaturityStatus: [''],
      tier4PaymentAmount: [''],
      tier4MetDate: [''],
      tier4PaidDate: [''],
      tier4PaymentDocumentNumber: [''],
      tier4InvoiceNumber: [''],
      tier4PaymentStatus: [''],
      tier4PaymentCentralTransactionId: [''],
      tier4MaturityDate: [''],
      tier4MaturityStatus: ['']
    });

    this.formSecuritySales = this.formBuilder.group({
      milestone2Designation: [''],
      payoutMetric: [''],
      tier1PaymentAmount: [''],
      tier1MetDate: [''],
      tier2PaymentAmount: [''],
      tier2MetDate: [''],
      tier3PaymentAmount: [''],
      tier3MetDate: [''],
      tier1PaidDate: [''],
      tier2PaidDate: [''],
      tier3PaidDate: [''],
      tier1PaymentDocumentNumber: [''],
      tier2PaymentDocumentNumber: [''],
      tier3PaymentDocumentNumber: [''],
      tier1InvoiceNumber: [''],
      tier2InvoiceNumber: [''],
      tier3InvoiceNumber: [''],
      tier1PaymentStatus: [''],
      tier2PaymentStatus: [''],
      tier3PaymentStatus: [''],
      tier1PaymentCentralTransactionId: [''],
      tier2PaymentCentralTransactionId: [''],
      tier3PaymentCentralTransactionId: [''],
      engagementSubID: [''],
      tier1MaturityDate: [''],
      tier2MaturityDate: [''],
      tier3MaturityDate: [''],
      tier1MaturityStatus: [''],
      tier2MaturityStatus: [''],
      tier3MaturityStatus: [''],
      tier4PaymentAmount: [''],
      tier4MetDate: [''],
      tier4PaidDate: [''],
      tier4PaymentDocumentNumber: [''],
      tier4InvoiceNumber: [''],
      tier4PaymentStatus: [''],
      tier4PaymentCentralTransactionId: [''],
      tier4MaturityDate: [''],
      tier4MaturityStatus: ['']
    });

    this.getDesignationsAndPaymentStatus();
  }

  getSpecialInvestmentMilestoneDetails(engagementId: number) {
    this.osmEdit
      .getSpecialInvestmentMilestonePayment(engagementId.toString())
      .subscribe(milestonePayments => {
        if (!milestonePayments) {
          return;
        }
        if (milestonePayments.length > 0) {
          this.hasMilestoneData = true;
        }

        milestonePayments.forEach(milestonePayment => {
          this.specialInvestmentsMilestonePayment = milestonePayment;
          if (milestonePayment.payoutMetric == 'Security ACR') {
            this.formSecurityACR = this.buildPaymentForm(milestonePayment);
            this.showSecurityACR = true;
            this.hasSecurityACR = true;
            this.hasVaildPayoutMetric = true;
          } else if (milestonePayment.payoutMetric == 'M365 Security Sales') {
            this.formSecuritySales = this.buildPaymentForm(milestonePayment);
            this.showM365SecuritySales = true;
            this.hasM365SecuritySales = true;
            this.hasVaildPayoutMetric = true;
          } else if (milestonePayment.payoutMetric == 'Sales Engagement') {
            this.formSalesEngagement = this.buildPaymentForm(milestonePayment);
            this.showSalesEngagement = true;
            this.selectedTab = 0;
            this.hasVaildPayoutMetric = true;
          } else if (milestonePayment.payoutMetric == 'Enabled Engagement') {
            this.formEnabledEngagement =
              this.buildPaymentForm(milestonePayment);
            this.showEnabledEngagement = true;
            this.selectedTab = 1;
            this.hasVaildPayoutMetric = true;
          }
        });
      });
  }

  buildPaymentForm(milestonePayment: SpecialInvestmentsMilestonePayment) {
    const tier1MetFormattedDate =
      milestonePayment.tier1MetDate == 'NULL'
        ? ''
        : this.datePipe.transform(milestonePayment.tier1MetDate, 'MM/dd/yyyy');
    const tier2MetFormattedDate =
      milestonePayment.tier2MetDate == 'NULL'
        ? ''
        : this.datePipe.transform(milestonePayment.tier2MetDate, 'MM/dd/yyyy');
    const tier3MetFormattedDate =
      milestonePayment.tier3MetDate == 'NULL'
        ? ''
        : this.datePipe.transform(milestonePayment.tier3MetDate, 'MM/dd/yyyy');
    const tier4MetFormattedDate =
      milestonePayment.tier4MetDate == 'NULL'
        ? ''
        : this.datePipe.transform(milestonePayment.tier4MetDate, 'MM/dd/yyyy');

    const tier1MaturityFormattedDate =
      milestonePayment.tier1MaturityDate == 'NULL'
        ? ''
        : this.datePipe.transform(
            milestonePayment.tier1MaturityDate,
            'MM/dd/yyyy'
          );
    const tier2MaturityFormattedDate =
      milestonePayment.tier2MaturityDate == 'NULL'
        ? ''
        : this.datePipe.transform(
            milestonePayment.tier2MaturityDate,
            'MM/dd/yyyy'
          );
    const tier3MaturityFormattedDate =
      milestonePayment.tier3MaturityDate == 'NULL'
        ? ''
        : this.datePipe.transform(
            milestonePayment.tier3MaturityDate,
            'MM/dd/yyyy'
          );
    const tier4MaturityFormattedDate =
      milestonePayment.tier4MaturityDate == 'NULL'
        ? ''
        : this.datePipe.transform(
            milestonePayment.tier4MaturityDate,
            'MM/dd/yyyy'
          );

    const tier1PaidFormattedDate = this.datePipe.transform(
      milestonePayment.tier1PaidDate,
      'MM/dd/yyyy'
    );
    const tier2PaidFormattedDate = this.datePipe.transform(
      milestonePayment.tier2PaidDate,
      'MM/dd/yyyy'
    );
    const tier3PaidFormattedDate = this.datePipe.transform(
      milestonePayment.tier3PaidDate,
      'MM/dd/yyyy'
    );
    const tier4PaidFormattedDate = this.datePipe.transform(
      milestonePayment.tier4PaidDate,
      'MM/dd/yyyy'
    );

    return this.formBuilder.group({
      payoutMetric: milestonePayment.payoutMetric,
      tier1PaymentAmount: milestonePayment.tier1PaymentAmount,
      tier2PaymentAmount: milestonePayment.tier2PaymentAmount,
      tier3PaymentAmount: milestonePayment.tier3PaymentAmount,
      tier4PaymentAmount: milestonePayment.tier4PaymentAmount,
      tier1MetDate: tier1MetFormattedDate,
      tier2MetDate: tier2MetFormattedDate,
      tier3MetDate: tier3MetFormattedDate,
      tier4MetDate: tier4MetFormattedDate,
      tier1PaidDate: tier1PaidFormattedDate,
      tier2PaidDate: tier2PaidFormattedDate,
      tier3PaidDate: tier3PaidFormattedDate,
      tier4PaidDate: tier4PaidFormattedDate,
      tier1InvoiceNumber: milestonePayment.tier1InvoiceNumber,
      tier2InvoiceNumber: milestonePayment.tier2InvoiceNumber,
      tier3InvoiceNumber: milestonePayment.tier3InvoiceNumber,
      tier4InvoiceNumber: milestonePayment.tier4InvoiceNumber,
      tier1PaymentCentralTransactionId:
        milestonePayment.tier1PaymentCentralTransactionId,
      tier2PaymentCentralTransactionId:
        milestonePayment.tier2PaymentCentralTransactionId,
      tier3PaymentCentralTransactionId:
        milestonePayment.tier3PaymentCentralTransactionId,
      tier4PaymentCentralTransactionId:
        milestonePayment.tier4PaymentCentralTransactionId,
      milestone2Designation: {
        designationId: milestonePayment.milestone2DesignationId,
        designationName:
          milestonePayment.milestone2DesignationId == null
            ? null
            : this.getMilestone2DesignationName(
                milestonePayment.milestone2DesignationId
              )
      },
      tier1PaymentDocumentNumber: milestonePayment.tier1PaymentDocumentNumber,
      tier2PaymentDocumentNumber: milestonePayment.tier2PaymentDocumentNumber,
      tier3PaymentDocumentNumber: milestonePayment.tier3PaymentDocumentNumber,
      tier4PaymentDocumentNumber: milestonePayment.tier4PaymentDocumentNumber,
      tier1PaymentStatus: {
        paymentStatusId: milestonePayment.tier1PaymentStatus,
        paymentStatusName:
          milestonePayment.tier1PaymentStatus == null
            ? null
            : this.getPaymentStatusName(milestonePayment.tier1PaymentStatus)
      },
      tier2PaymentStatus: {
        paymentStatusId: milestonePayment.tier2PaymentStatus,
        paymentStatusName:
          milestonePayment.tier2PaymentStatus == null
            ? null
            : this.getPaymentStatusName(milestonePayment.tier2PaymentStatus)
      },
      tier3PaymentStatus: {
        paymentStatusId: milestonePayment.tier3PaymentStatus,
        paymentStatusName:
          milestonePayment.tier3PaymentStatus == null
            ? null
            : this.getPaymentStatusName(milestonePayment.tier3PaymentStatus)
      },
      tier4PaymentStatus: {
        paymentStatusId: milestonePayment.tier4PaymentStatus,
        paymentStatusName:
          milestonePayment.tier4PaymentStatus == null
            ? null
            : this.getPaymentStatusName(milestonePayment.tier4PaymentStatus)
      },
      engagementSubID: milestonePayment.engagementSubID,
      tier1MaturityDate: tier1MaturityFormattedDate,
      tier2MaturityDate: tier2MaturityFormattedDate,
      tier3MaturityDate: tier3MaturityFormattedDate,
      tier4MaturityDate: tier4MaturityFormattedDate,
      tier1MaturityStatus: milestonePayment.tier1MaturityStatus,
      tier2MaturityStatus: milestonePayment.tier2MaturityStatus,
      tier3MaturityStatus: milestonePayment.tier3MaturityStatus,
      tier4MaturityStatus: milestonePayment.tier4MaturityStatus,
      tenantId: milestonePayment.tenantId,
      isAcceleratedPayment: milestonePayment.isAcceleratedPayment
    });
  }

  getDesignationsAndPaymentStatus() {
    const getPaymentStatus = this.osmEdit.getMilestone2PaymentStatusDropdown();
    const getDesignations = this.osmEdit.getMilestone2DesignationDropdown();
    const getMilestone2Details =
      this.osmEdit.getSpecialInvestmentMilestone2Details(
        this.engagementId.toString()
      );

    forkJoin([
      getPaymentStatus,
      getDesignations,
      getMilestone2Details
    ]).subscribe(results => {
      this.paymentStatus = results[0];
      if (this.programTypeId != this.ProgramType.Operator) {
        this.paymentStatus = this.paymentStatus.filter(
          st => !this.operatorPaymentStatus.includes(st.paymentStatusName || '')
        );
      }

      this.milestone2Designations = results[1];
      this.milestone2Details = results[2];
      if (this.milestone2Details.showDesignation == true) {
        this.showDesignation = true;

        const placeholderDesignation: Milestone2Designation = {
          designationId: undefined,
          designationName: 'Select'
        };

        this.milestone2Designations.unshift(placeholderDesignation);
        this.selectedDesignation = this.milestone2Designations[0];

        if (this.milestone2Details) {
          this.selectedDesignation = this.milestone2Designations.find(
            x => x.designationId == this.milestone2Details.designationId
          );
        }
      }

      this.getSpecialInvestmentMilestoneDetails(this.engagementId);
    });
  }

  onSubmitMilestone2PaymentInvoice(formMilestone2Payment: FormGroup) {
    this.specialInvestmentsMilestone2Invoice = {
      engagementId: this.engagementId.toString(),
      tier1InvoiceNumber:
        formMilestone2Payment.controls['tier1InvoiceNumber'].value,
      tier1PaidDate: formMilestone2Payment.controls['tier1PaidDate'].value,
      tier1PaymentCentralTransactionId:
        formMilestone2Payment.controls['tier1PaymentCentralTransactionId']
          .value,
      tier1PaymentStatus:
        formMilestone2Payment.controls['tier1PaymentStatus'].value === null
          ? this.getPaymentStatus(
              formMilestone2Payment.controls['tier1MaturityStatus'].value
            )
          : formMilestone2Payment.controls['tier1PaymentStatus'].value
              .paymentStatusId,
      tier2InvoiceNumber:
        formMilestone2Payment.controls['tier2InvoiceNumber'].value,
      tier2PaidDate: formMilestone2Payment.controls['tier2PaidDate'].value,
      tier2PaymentCentralTransactionId:
        formMilestone2Payment.controls['tier2PaymentCentralTransactionId']
          .value,
      tier2PaymentStatus:
        formMilestone2Payment.controls['tier2PaymentStatus'].value === null
          ? this.getPaymentStatus(
              formMilestone2Payment.controls['tier2MaturityStatus'].value
            )
          : formMilestone2Payment.controls['tier2PaymentStatus'].value
              .paymentStatusId,
      tier3InvoiceNumber:
        formMilestone2Payment.controls['tier3InvoiceNumber'].value,
      tier3PaidDate: formMilestone2Payment.controls['tier3PaidDate'].value,
      tier3PaymentCentralTransactionId:
        formMilestone2Payment.controls['tier3PaymentCentralTransactionId']
          .value,
      tier3PaymentStatus:
        formMilestone2Payment.controls['tier3PaymentStatus'].value === null
          ? this.getPaymentStatus(
              formMilestone2Payment.controls['tier3MaturityStatus'].value
            )
          : formMilestone2Payment.controls['tier3PaymentStatus'].value
              .paymentStatusId,
      tier4InvoiceNumber:
        formMilestone2Payment.controls['tier4InvoiceNumber'].value,
      tier4PaidDate: formMilestone2Payment.controls['tier4PaidDate'].value,
      tier4PaymentCentralTransactionId:
        formMilestone2Payment.controls['tier4PaymentCentralTransactionId']
          .value,
      tier4PaymentStatus:
        formMilestone2Payment.controls['tier4PaymentStatus'].value === null
          ? this.getPaymentStatus(
              formMilestone2Payment.controls['tier4MaturityStatus'].value
            )
          : formMilestone2Payment.controls['tier4PaymentStatus'].value
              .paymentStatusId,
      engagementSubID: formMilestone2Payment.controls['engagementSubID'].value,
      payoutMetric: formMilestone2Payment.controls['payoutMetric'].value,
      tier1PaymentDocumentNumber:
        formMilestone2Payment.controls['tier1PaymentDocumentNumber'].value,
      tier2PaymentDocumentNumber:
        formMilestone2Payment.controls['tier2PaymentDocumentNumber'].value,
      tier3PaymentDocumentNumber:
        formMilestone2Payment.controls['tier3PaymentDocumentNumber'].value,
      tier4PaymentDocumentNumber:
        formMilestone2Payment.controls['tier4PaymentDocumentNumber'].value
    };

    this.osmEdit
      .updateSpecialInvestmentMilestone2InvoiceDetails(
        this.specialInvestmentsMilestone2Invoice
      )
      .subscribe(
        messageResponse => {
          this.apires = messageResponse;
          if (this.apires.success === true) {
            this.msgsMilestone2InvoiceDetails = [];
            this.msgsMilestone2InvoiceDetails.push({
              severity: 'success',
              detail: 'Milestone 2 Invoice Details Saved Successfully.'
            });
            this.isReadonlyMilestone2Payment = true;
            this.paymentMilestone2btnNav = false;
            this.formSecuritySales.disable();
          }
          if (this.apires.success === false) {
            this.msgsMilestone2InvoiceDetails = [];
            this.msgsMilestone2InvoiceDetails.push({
              severity: 'error',
              detail: this.apires.errorMessages
                ? this.apires.errorMessages[0]
                : 'Unknown error'
            });
          }
        },
        error => {
          this.msgsMilestone2InvoiceDetails = [];
          let errors: string[] = [];
          if (error.status === 400) {
            errors = this.commonService.getBadRequestErrors(error);
            for (const msg of errors) {
              this.msgsMilestone2InvoiceDetails.push({
                severity: 'warn',
                detail: msg
              });
            }
          } else {
            this.msgsMilestone2InvoiceDetails.push({
              severity: 'warn',
              detail:
                'Sorry an error occured while updating milestone 2 invoice details'
            });
          }
        }
      );
  }

  getPaymentStatus(maturityStatus: string) {
    if (this.programTypeId == this.ProgramType.Operator) {
      if (maturityStatus == MaturityStatus.Mature) {
        return PaymentStatus.Readyforpayment;
      } else if (maturityStatus == MaturityStatus.Immature) {
        return PaymentStatus.Immature;
      } else if (maturityStatus == MaturityStatus.TierDowngrade) {
        return PaymentStatus.TierNotMet;
      } else if (maturityStatus == MaturityStatus.Ineligible) {
        return PaymentStatus.Expired;
      }
    }
    return null;
  }

  editMilestone2PaymentCancel(formMilestone2Payment: FormGroup) {
    this.msgsMilestone2InvoiceDetails = [];
    this.msgsMilestone2Details = [];
    this.isReadonlyMilestone2Payment = false;
    this.paymentMilestone2btnNav = true;
    this.cancelSpecialInvestmentMilestone2Payment(
      this.engagementId,
      formMilestone2Payment
    );
  }

  editSpecialInvestmentMilestone2Payment() {
    this.msgsMilestone2Details = [];
    this.isReadonlyMilestone2Payment = false;
    this.paymentMilestone2btnNav = true;
  }

  editMilestone2DesignationCancel() {
    this.msgsMilestone2Details = [];
    this.isReadonlyMilestone2Payment = true;
    this.paymentMilestone2btnNav = false;
    this.editSpecialInvestmentMilestone2Designation();
  }

  editSpecialInvestmentMilestone2Designation() {
    this.msgsMilestone2Details = [];
    this.isReadonlyMilestone2Details = false;
    this.paymentMilestone2DesignationbtnNav = true;
  }

  cancelSpecialInvestmentMilestone2Payment(
    engagementId: number,
    formMilestone2Payment: FormGroup
  ) {
    const payoutMetric = formMilestone2Payment.controls['payoutMetric'].value;

    this.osmEdit
      .getSpecialInvestmentMilestonePayment(engagementId.toString())
      .subscribe(results => {
        if (results) {
          const result = results.find(
            payment => payment.payoutMetric == payoutMetric
          );

          formMilestone2Payment.patchValue({
            milestone2Designation: result?.milestone2DesignationId,
            tier1InvoiceNumber: result?.tier1InvoiceNumber,
            tier2InvoiceNumber: result?.tier2InvoiceNumber,
            tier3InvoiceNumber: result?.tier3InvoiceNumber,
            tier4InvoiceNumber: result?.tier4InvoiceNumber,
            tier1PaidDate: this.datePipe.transform(
              result?.tier1PaidDate,
              'MM/dd/yyyy'
            ),
            tier2PaidDate: this.datePipe.transform(
              result?.tier2PaidDate,
              'MM/dd/yyyy'
            ),
            tier3PaidDate: this.datePipe.transform(
              result?.tier3PaidDate,
              'MM/dd/yyyy'
            ),
            tier4PaidDate: this.datePipe.transform(
              result?.tier4PaidDate,
              'MM/dd/yyyy'
            ),
            tier1PaymentCentralTransactionId:
              result?.tier1PaymentCentralTransactionId,
            tier2PaymentCentralTransactionId:
              result?.tier2PaymentCentralTransactionId,
            tier3PaymentCentralTransactionId:
              result?.tier3PaymentCentralTransactionId,
            tier4PaymentCentralTransactionId:
              result?.tier4PaymentCentralTransactionId,
            engagementSubID: result?.engagementSubID
          });

          formMilestone2Payment.controls['milestone2Designation'].setValue({
            designationId: result?.milestone2DesignationId,
            designationName:
              result?.milestone2DesignationId == null
                ? null
                : this.getMilestone2DesignationName(
                    result?.milestone2DesignationId
                  )
          });
          formMilestone2Payment.controls['tier1PaymentStatus'].setValue({
            paymentStatusId: result?.tier1PaymentStatus,
            paymentStatusName:
              result?.tier1PaymentStatus == null
                ? null
                : this.getPaymentStatusName(result?.tier1PaymentStatus)
          });
          formMilestone2Payment.controls['tier2PaymentStatus'].setValue({
            paymentStatusId: result?.tier2PaymentStatus,
            paymentStatusName:
              result?.tier2PaymentStatus == null
                ? null
                : this.getPaymentStatusName(result?.tier2PaymentStatus)
          });
          formMilestone2Payment.controls['tier3PaymentStatus'].setValue({
            paymentStatusId: result?.tier3PaymentStatus,
            paymentStatusName:
              result?.tier3PaymentStatus == null
                ? null
                : this.getPaymentStatusName(result?.tier3PaymentStatus)
          });

          formMilestone2Payment.controls['tier4PaymentStatus'].setValue({
            paymentStatusId: result?.tier4PaymentStatus,
            paymentStatusName:
              result?.tier4PaymentStatus == null
                ? null
                : this.getPaymentStatusName(result?.tier4PaymentStatus)
          });
        } else {
          this.clearFormValues(formMilestone2Payment);
        }
      });
  }

  clearFormValues(formMilestone2Payment: FormGroup) {
    formMilestone2Payment.patchValue({
      milestone2Designation: '',
      tier1InvoiceNumber: '',
      tier2InvoiceNumber: '',
      tier3InvoiceNumber: '',
      tier4InvoiceNumber: '',
      tier1PaidDate: '',
      tier2PaidDate: '',
      tier3PaidDate: '',
      tier4PaidDate: '',
      tier1PaymentCentralTransactionId: '',
      tier2PaymentCentralTransactionId: '',
      tier3PaymentCentralTransactionId: '',
      tier4PaymentCentralTransactionId: '',
      tier1PaymentStatus: '',
      tier2PaymentStatus: '',
      tier3PaymentStatus: '',
      tier4PaymentStatus: ''
    });
  }

  getPaymentStatusName(paymentStatusId: number) {
    return this.paymentStatus.find(p => p.paymentStatusId == paymentStatusId)
      ?.paymentStatusName;
  }

  getMilestone2DesignationName(designationId: number) {
    return this.milestone2Designations.find(
      p => p.designationId == designationId
    )?.designationName;
  }
  get ProgramType() {
    return ProgramTypes;
  }

  onSubmitMilestone2Designation() {
    if (this.selectedDesignation.designationId) {
      this.specialInvestmentsMilestone2Details = {
        engagementId: this.engagementId,
        designationId:
          this.selectedDesignation == null
            ? null
            : this.selectedDesignation.designationId,
        showDesignation: this.showDesignation
      };

      this.osmEdit
        .updateSpecialInvestmentMilestone2Details(
          this.specialInvestmentsMilestone2Details
        )
        .subscribe(
          messageResponse => {
            this.apires = messageResponse;
            if (this.apires.success === true) {
              this.msgsMilestone2Details = [];
              this.msgsMilestone2Details.push({
                severity: 'success',
                detail: 'Milestone 2 Designation Saved Successfully.'
              });
              this.isReadonlyMilestone2Details = false;
              this.paymentMilestone2DesignationbtnNav = true;
            }
            if (this.apires.success === false) {
              this.msgsMilestone2Details = [];
              this.msgsMilestone2Details.push({
                severity: 'error',
                detail: this.apires.errorMessages
                  ? this.apires.errorMessages[0]
                  : 'Unknown error'
              });
            }
          },
          error => {
            this.msgsMilestone2Details = [];
            let errors: string[] = [];
            if (error.status === 400) {
              errors = this.commonService.getBadRequestErrors(error);
              for (const msg of errors) {
                this.msgsMilestone2Details.push({
                  severity: 'warn',
                  detail: msg
                });
              }
            } else {
              this.msgsMilestone2Details.push({
                severity: 'warn',
                detail:
                  'Sorry an error occured while updating milestone 2 designation'
              });
            }
          }
        );
    } else {
      this.msgsMilestone2Details = [];
      this.msgsMilestone2Details.push({
        severity: 'warn',
        detail: 'Please select Milestone 2 Designation'
      });
    }
  }
}
